export default __webpack_public_path__ + "static/media/Cool.3ed532c6.png";